<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab">
    <section class="apps-entry" slot="view">
      <div class="apps-entry-content">
          <div class="step-panle">
            <div class="rules-head">
              <div style="float:right">
                <Button type="default" v-if="isToExamine">已审核</Button>
              </div>
              <h1 style="text-align:left">员工信息</h1>
            </div>
            <div class="rules-content">
              <div class="ivu-table ivu-table-border apps-entry-table">
                <div class="ivu-table-body">
                    <h3 style="padding:20px 0">单位信息</h3>
                    <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%">
                      <tbody class="iv-table-tbody">
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">入职单位</div></th>
                          <td>
                            <div class="ivu-table-cell" style="padding:8px">
                              <template v-if="!companyNameEdit">
                                {{userResume.company_name||'未选择'}} <Button type="info" size="small" @click="companyNameEdit=true">修改</Button>
                              </template>
                              <Select v-model="userResume.company_name" @on-change="companyNameChange" v-else>
                                <Option value="浙江宇脉科技股份有限公司"></Option>
                                <Option value="杭州领优信息科技有限公司">杭州领优信息科技有限公司</Option>
                              </Select>
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">入职类型</div></th>
                          <td>
                            <div class="ivu-table-cell" style="padding:8px">
                              <template v-if="!staffTypeEdit">
                                {{userResume.staff_type||'未选择'}} <Button type="info" size="small" @click="staffTypeEdit=true">修改</Button>
                              </template>
                              <Select v-model="userResume.staff_type" @on-change="staffTypeChange" v-else>
                                <Option value="正式员工"></Option>
                                <Option value="实习生">实习生</Option>
                                <Option value="非正式员工(自由人)">非正式员工(自由人)</Option>
                              </Select>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <h3 style="padding:20px 0">个人信息</h3>
                    <table style="border:1px solid #e9eaec;border-collapse: collapse;min-width:600px">
                      <tbody class="iv-table-tbody">
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">中文姓名</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{userResume.name||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">英文姓名</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{userResume.ename||'未填写'}}
                            </div>
                          </td>
                          <td rowspan="3" width="100" style="border:1px solid #e9eaec;text-align:center">
                            <div class="resume-avatar" style="position:relative;height:144px;left:0;top:0;background:#eee">
                              <label for="avatarFile" style="position:absolute;top:0;left:0;width:100%;z-index:2">
                                <img :src="getImage(userResume.avatar)" if="userResume.avatar!=null" style="width:90px;height:134px;margin:5px;">
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">出生年月</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.birthday||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">性别</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{userResume.gender||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">政治面貌</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.political_status||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">身高</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.height||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">所学专业</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.major||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">最高学历</div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{userResume.education||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">籍贯</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.origin_place||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">户口所在地</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.reg_place||'未填写'}}
                            </div>
                          </td>
                          <td>
                            <div class="ivu-table-cell" style="text-align:center">
                              {{userResume.hkxz}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">家庭地址</div></th>
                          <td colspan="5">
                            <div class="ivu-table-cell">
                                {{userResume.address||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">家庭电话</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.tel||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">身份证<br><span style="color:#999">(或护照号)</span></div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{userResume.id_number||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">手机号码</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{userResume.mobile||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">邮箱地址</div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{userResume.email||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">婚姻状况</div></th>
                          <td colspan="5">
                            <div class="ivu-table-cell">
                              {{userResume.marital_status||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">学习经历</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                              <table style="width:100%;border-collapse: collapse;">
                                <tbody>
                                  <tr class="ivu-table-row">
                                    <th style="width:130px"><div class="ivu-table-cell">时间</div></th>
                                    <th style="text-align:center;width:auto"><div class="ivu-table-cell"></div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">学历</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">专业</div></th>
                                  </tr>
                                  <tr class="ivu-table-row" v-for="(item, index) in userResume.edu_exp" :key="index">
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.time||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.con||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.edu||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.major||'未填写'}}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">工作经历</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                              <table style="width:100%;border-collapse: collapse;">
                                <tbody>
                                  <tr class="ivu-table-row">
                                    <th style="text-align:center;width:130px"><div class="ivu-table-cell">时间</div></th>
                                    <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">职务</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">离职原因</div></th>
                                  </tr>
                                </tbody>
                                <tbody v-for="(item, index) in userResume.work_exp" :key="index">
                                  <tr class="ivu-table-row">
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.time||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.unit||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.post||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.reason||'未填写'}}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                  <td colspan="4">
                                    <div class="ivu-table-cell" style="padding:5px;">
                                      {{item.detail}}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">特殊技能</div></th>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">获得的证书情况</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书名称</div></th>
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">获得时间</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">颁发单位</div></th>
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书是否在公司备案</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in userResume.certificate" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.time||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.unit||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      {{item.redord||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">紧急情况联系人</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">联系地址</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">私人邮箱</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in userResume.content" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.relation||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.address||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.tel||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.email||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">家庭成员</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in userResume.family" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.relation||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.tel||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.unit||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">备注</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <div class="ivu-table-cell" style="padding:8px">
                              {{userResume.remarks||'未填写'}}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                     <h3 style="padding:20px 0">银行信息 <small></small></h3>
                  <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%">
                    <tbody class="iv-table-tbody">
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">开户姓名</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{userResume.bank.name||'未填写'}}
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">开户行</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{userResume.bank.bank_name||'未填写'}}
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">行号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{userResume.bank.number||'未填写'}}
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">银行卡号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{userResume.bank.card_number||'未填写'}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="apps-entry-content">
          <div class="step-panle">
            <div class="rules-head">
              <div style="float:right">
                <Button type="default" v-if="isToExamine">已审核</Button>
              </div>
              <h1 style="text-align:left">上传资料</h1>
            </div>
            <div class="rules-content">
              <h4>身份证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                      <div class="upload-item-img" @click="viewImg(uploads.id_card_f)">
                          <template v-if="uploads.id_card_f != null">
                              <img :src="uploads.id_card_f" style="height:100%">
                          </template>
                      </div>
                    </div>
                  </div>
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img" @click="viewImg(uploads.id_card_b)">
                            <template v-if="uploads.id_card_b != null">
                                <img :src="uploads.id_card_b" style="height:100%">
                            </template>
                        </div>
                    </div>
                  </div>
              </div>
              <h4>学历证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                      <div class="upload-item-wrap">
                          <div class="upload-item-img" @click="viewImg(uploads.education_certificate)">
                              <template v-if="uploads.education_certificate != null">
                                  <img :src="uploads.education_certificate" style="height:100%">
                              </template>
                          </div>
                      </div>
                  </div>
              </div>
              <h4>学位证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img" @click="viewImg(uploads.degree_certificate)">
                            <template v-if="uploads.degree_certificate != null">
                                <img :src="uploads.degree_certificate" style="height:100%">
                            </template>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
            <div class="rules-foot" style="text-align:center;clear:both;position:static">
              <Alert style="width:300px;margin:0 auto;text-align:left;margin-bottom:15px" v-if="entryInfo.type!=''">
                审核历史
                <template slot="desc">
                  {{this.entryInfo.remarks}}
                </template>
              </Alert>
              <div style="">
                <Button type="primary" size="large" @click="submitEntryModel=true" v-if="!isToExamine">{{this.entryInfo.type==''?'提交审核内容':'修改审核内容'}}</Button>
                <Button type="default" size="large" @click="submitEntryModel=true" v-else>已经审核,点击修改</Button>
              </div>
            </div>
          </div>
        <Modal v-model="viewImgModel" width="90%" :styles="{'marginBottom': '40px'}">
          <img :src="viewImgPath" width="100%">
          <div slot="footer"></div>
        </Modal>
        <Modal v-model="submitEntryModel" title="审核" width="500px" :styles="{'marginBottom': '40px'}">
            <Form ref="entryInfo" :model="entryInfo" :rules="ruleValidate" label-position="top" >
              <FormItem label="试用期：" prop="remarks">
                <Select v-model="entryInfo.time_limit" style="width:49%;display:inline-block">
                  <Option :value="0">无试用期</Option>
                  <Option v-for="(value, ind) in 12" :value="value" :key="ind">{{value}} 月</Option>
                </Select>
                <span v-if="entryInfo.time_limit>0" style="display:inline-block;width:50%;vertical-align:top">
                  <Input v-model="entryInfo.test_salary" placeholder="请输入试用期薪资">
                    <span slot="prepend">薪资</span>
                    <span slot="append">元/月</span>
                  </Input>
                </span>
              </FormItem>
              <FormItem label="转正后薪资：" prop="salary">
                <Input v-model="entryInfo.salary" placeholder="请输入薪资">
                  <span slot="append">元/月</span>
                </Input>
              </FormItem>
              <span style="border-bottom:1px solid #eee;display:block;margin-bottom:24px;"></span>
              <Row :gutter="15">
                <Col span="12">
                  <FormItem label="是否需交社保:">
                    <RadioGroup v-model="is_social_security">
                      <Radio :label="0">无社保</Radio>
                      <Radio :label="1">有社保</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem label="社保缴纳时间：" v-if="is_social_security==1" >
                    <DatePicker v-model="entryInfo.social_security" format="yyyy/MM/dd" placeholder="请选择社保缴纳时间"></DatePicker>
                  </FormItem>
                  <FormItem label="社保缴纳地：" v-if="is_social_security==1">
                    <Input v-model="entryInfo.social_security_city" placeholder="请输入社保缴纳地"></Input>
                  </FormItem>
                </Col>
              </Row>
              <span style="border-bottom:1px solid #eee;display:block;margin-bottom:24px;"></span>
              <Row :gutter="15">
                <Col span="12">
                  <FormItem label="从事专业：">
                    <Cascader :data="selectData" v-model="entryInfo.job_name" trigger="hover"></Cascader>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem label="推荐人：">
                    <Input v-model="entryInfo.bole" placeholder="请输入推荐人"></Input>
                  </FormItem>
                </Col>
              </Row>
              <span style="border-bottom:1px solid #eee;display:block;margin-bottom:24px;"></span>
              <FormItem label="审核状态：" prop="type">
                  <Select v-model="entryInfo.type">
                    <Option :value="'信息错误'" :label="'信息错误'">信息错误</Option>
                    <Option :value="'审核通过'" :label="'审核通过'">审核通过</Option>
                  </Select>
              </FormItem>
              <FormItem label="审核描述：" prop="remarks">
                <Input v-model="entryInfo.remarks" placeholder="描述审核信息" type="textarea"></Input>
              </FormItem>
            </Form>
            <footer slot="footer">
              <Button type="primary" size="large" @click="submitToExamine('entryInfo')">提交审核</Button>
            </footer>
        </Modal>
      </section>
  </content-layout>
</template>

<script>
  import {fetch, put, post} from '../fetch/api'
  import validate from '../util/validateForm'
  const baseDate = {
    edu_exp: {time: '', con: '', edu: '', major: ''},
    work_exp: {time: '', unit: '', post: '', reason: ''},
    certificate: {name: '', time: '', unit: '', redord: '是'},
    content: {name: '', relation: '', address: '', tel: '', email: ''},
    family: {name: '', relation: '', tel: '', unit: ''}
  }
  const resumeData = {
    id: 0,
    name: '',
    ename: '',
    birthday: '',
    company_name: '',
    staff_type: '',
    gender: '',
    avatar: '',
    political_status: '',
    height: '',
    major: '',
    education: '',
    origin_place: '',
    reg_place: '',
    address: '',
    tel: '',
    email: '',
    mobile: '',
    id_number: '',
    marital_status: '',
    edu_exp: [baseDate.edu_exp],
    work_exp: [baseDate.work_exp],
    bank: {
      name: '',
      card_number: '',
      number: '',
      bank_name: ''
    },
    certificate: [baseDate.certificate],
    content: [baseDate.content],
    family: [baseDate.family],
    remarks: ''
  }

  export default {
    name: 'EntryPage',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      const checkPhone = (rule, value, callback) => {
        let res = validate.phone(value)
        if (res !== true) {
          callback(new Error(res))
        } else {
          callback()
        }
      }
      return {
        title: '入职资料',
        activeTab: '',
        tabs: [
          {'title': '入职资料审核', 'key': 'view', 'visible': true}
        ],
        headImage: '/static/images/bg/money.jpeg',
        uploadApiPath: '/api/users/upfile',
        defaultList: [],
        isToExamine: false,
        token: token,
        contractPath: null,
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        submitEntryModel: false,
        companyNameEdit: false,
        staffTypeEdit: false,
        viewImgModel: false,
        viewImgPath: null,
        userResume: JSON.parse(JSON.stringify(resumeData)),
        uploads: {
          id_card_f: null,
          id_card_b: null,
          education_certificate: null,
          degree_certificate: null
        },
        is_social_security: 0,
        entryInfo: {
          type: '',
          job_name: [],
          salary: '',
          remarks: '',
          test_salary: '',
          time_limit: 3,
          social_security: '',
          social_security_city: '',
          bole: ''
        },
        maxSize: 500,
        uploadList: [],
        rulesModal: false,
        rulesIsRead: false,
        required: {required: true, message: '请输入', trigger: 'blur'},
        ruleData: {
          birthday: [
            {required: true, message: '请输入出生日期', trigger: 'blur'}
          ],
          mobile: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {validator: checkPhone, trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'change'},
            { type: 'email', message: '邮箱地址格式错误', trigger: 'blur' }
          ],
          password: [
            {required: true, min: 6, message: '请输入密码，必须大于6个字符！', trigger: 'blur'}
          ]
        },
        ruleValidate: {
          salary: [
            {required: true, message: '请输入薪资', trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择审核状态', trigger: 'change'}
          ],
          time: [
            {required: true, message: '请选择社保缴纳时间', trigger: 'blur'}
          ]
        },
        selectData: [
          {
            value: '无线设计',
            label: '无线设计',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '设计人员',
                label: '设计人员'
              },
              {
                value: '专业负责人',
                label: '专业负责人'
              },
              {
                value: '项目经理',
                label: '项目经理'
              }
            ]
          },
          {
            value: '传输设计',
            label: '传输设计',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '设计人员',
                label: '设计人员'
              },
              {
                value: '专业负责人',
                label: '专业负责人'
              },
              {
                value: '项目经理',
                label: '项目经理'
              },
              {
                value: '项目支撑',
                label: '项目支撑'
              }
            ]
          },
          {
            value: 'GSM网优',
            label: 'GSM网优',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '初级',
                label: '初级'
              },
              {
                value: '中级',
                label: '中级'
              },
              {
                value: '高级',
                label: '高级'
              }
            ]
          },
          {
            value: 'CDMA网优',
            label: 'CDMA网优',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '初级',
                label: '初级'
              },
              {
                value: '中级',
                label: '中级'
              },
              {
                value: '高级',
                label: '高级'
              }
            ]
          },
          {
            value: 'TD网优',
            label: 'TD网优',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '初级',
                label: '初级'
              },
              {
                value: '中级',
                label: '中级'
              },
              {
                value: '高级',
                label: '高级'
              }
            ]
          },
          {
            value: 'WCDMA网优',
            label: 'WCDMA网优',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '初级',
                label: '初级'
              },
              {
                value: '中级',
                label: '中级'
              },
              {
                value: '高级',
                label: '高级'
              }
            ]
          },
          {
            value: 'LTE网优',
            label: 'LTE网优',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '初级',
                label: '初级'
              },
              {
                value: '中级',
                label: '中级'
              },
              {
                value: '高级',
                label: '高级'
              }
            ]
          },
          {
            value: '行政综管',
            label: '行政综管',
            children: [
              {
                value: '实习生',
                label: '实习生'
              },
              {
                value: '行政专员',
                label: '行政专员'
              }
            ]
          },
          {
            value: '其他',
            label: '其他',
            children: [
              {
                value: '项目支撑',
                label: '项目支撑'
              }
            ]
          }
        ]
      }
    },
    mounted () {
      this.fetchEntryInfo()
    },
    methods: {
      fetchEntryInfo () {
        let uid = this.$route.params.id
        fetch(`/users/entry/info/${uid}`).then(res => {
          if (res.status === 'ok') {
            let data = res.resume
            if (data !== null) {
              data['edu_exp'] = JSON.parse(data['edu_exp'])
              data['work_exp'] = JSON.parse(data['work_exp'])
              // data['special_skill'] = JSON.parse(data['special_skill'])
              data['certificate'] = JSON.parse(data['certificate'])
              data['content'] = JSON.parse(data['content'])
              data['family'] = JSON.parse(data['family'])
              data['bank'] = (data['bank'] === null || data['bank'] === '') ? {} : JSON.parse(data['bank'])
              this.userResume = res.resume
            }
            // if (res.contract !== null) {
            //   this.contractData = JSON.parse(res.contract.sign_info)
            //   this.contractPath = `${this.apiPath}/api/console/pdf?type=pdf&path=${res.contract.file_path}&token=${this.token}`
            // }

            this.isToExamine = res.entry_status === 2
            if (res.entry_info !== null) {
              this.entryInfo = res.entry_info
              this.entryInfo.time_limit = Number(this.entryInfo.time_limit)
              this.entryInfo.job_name = this.entryInfo.job_name.split('/')
              this.is_social_security = this.entryInfo.social_security === '无社保' ? 0 : 1
            }
            if (res.files !== null) {
              for (let k in res.files) {
                let _file = res.files[k]
                if (_file.file_type === 'id_card_f') this.uploads.id_card_f = this.getImage(_file.file_path)
                if (_file.file_type === 'id_card_b') this.uploads.id_card_b = this.getImage(_file.file_path)
                if (_file.file_type === 'education_certificate') this.uploads.education_certificate = this.getImage(_file.file_path)
                if (_file.file_type === 'degree_certificate') this.uploads.degree_certificate = this.getImage(_file.file_path)
              }
            }
          }
        })
      },
      viewContract () {
        let dom = document.getElementById('contractHtml')
        let uid = this.$route.params.id
        let html = dom.innerHTML

        put(`/users/contract/view/${uid}`, {'html': html})
        // .then(res => {
        //   if (res.status === 'ok') {
        //   }
        // })
      },
      editContract () {
        let data = {
          'user_id': this.$route.params.id,
          'sign_info': JSON.stringify(this.contractData)
        }
        if (this.contractData.name === '') {
          this.$Message.error('请输入乙方姓名')
          return false
        }
        if (this.contractData.birthday === '') {
          this.$Message.error('请输入乙方出生日期')
          return false
        }
        if (this.contractData.gender === '') {
          this.$Message.error('请输入乙方性别')
          return false
        }
        if (this.contractData.phone === '') {
          this.$Message.error('请输入乙方联系电话')
          return false
        }
        if (this.contractData.id_number === '') {
          this.$Message.error('请输入乙方身份证号码')
          return false
        }
        if (this.contractData.job_name === '') {
          this.$Message.error('请输入您从事的工作')
          return false
        }
        if (this.contractData.signature === null) {
          this.$Message.error('请您签名')
          return false
        }
        if (this.contractData.sign_year === '') {
          this.$Message.error('请输入签约日期')
          return false
        }
        if (this.contractData.sign_month === '') {
          this.$Message.error('请输入签约日期')
          return false
        }
        if (this.contractData.sign_day === '') {
          this.$Message.error('请输入签约日期')
          return false
        }

        post('/users/contract', data).then(() => {
          // if (res.status === 'ok') {
          // }
        })
      },
      submitToExamine (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.entryInfo))
            data['job_name'] = data.job_name.join('/')
            console.log(data)
            if (data['type'] === null || data['type'] === '') {
              this.$Message.error('请选择审核状态')
              return false
            }
            if (this.is_social_security === 0) data.social_security = '无社保'
            if (data.social_security === '') {
              this.$Message.error('请输入社保缴纳时间')
              return false
            }
            data['user_id'] = this.$route.params.id

            post('/console/entryInfo', data).then(res => {
              if (res.status === 'ok') {
                this.submitEntryModel = false
                if (this.entryInfo.type === '审核通过') {
                  this.isToExamine = 2
                } else {
                  this.isToExamine = 0
                }
              }
            })
          }
        })
      },
      viewImg (img) {
        this.viewImgModel = true
        this.viewImgPath = img
      },
      getImage (path) {
        return path ? `/api/console/file?path=${path}&token=${this.token}`: ''
      },
      companyNameChange () {
        this.submitResume()
        this.companyNameEdit = false
      },
      staffTypeChange () {
        this.submitResume()
        this.staffTypeEdit = false
      },
      submitResume () {
        let data = JSON.parse(JSON.stringify(this.userResume))
        put(`/users/resume`, data).then(() => {
          this.$Message.info('修改成功')
        })
      }
    }
  }
</script>
<style>
  .apps-entry-table .ivu-table-cell{padding:0 6px;}
  .apps-entry-table .ivu-form-item{margin:0 auto;}
  .apps-entry-table .ivu-form-item-error-tip{top:5px;right:5px;left:auto;}
  .apps-entry-table.ivu-table:before{display: none;}
  .apps-entry-table th{width:80px;text-align: right}
  .apps-entry-steps.ivu-steps .ivu-steps-head,
  .apps-entry-steps.ivu-steps .ivu-steps-title{background: none;}
</style>
<style scoped>
  .avatar-file{display: none}
  .apps-entry{
    margin: auto 0;
  }
  .apps-entry-content{
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 40px;
    position: relative;
  }
  .apps-entry-title{
    margin-bottom: 10px;
  }
  .apps-entry-steps-buttons{
    padding: 5px 34px;
  }
  .rules-head{
    border-bottom: 1px solid #eee;
    padding:20px 20px 10px;
  }
  .rules-foot{
    width: 100%;
    padding: 20px 0;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
  }
  .rules-content{
    padding: 10px 20px 100px;
    border-width: 1px 0;
  }
  .rules-content h4{margin:10px 0;color:#666;}
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .upload-box{margin-bottom: 20px;}
  .upload-item{
    width:256px;
    display: inline-block;
    margin-left: 15px;
  }
  .upload-item-wrap{
    width: 256px;
    height: 160px;
    overflow: hidden;
    background-color: #f7f7f7
  }
  .upload-item-img{
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 6px;
  }
  .upload-item-img,
  .upload-item-img img{height: 100%}
  .upload-item-cover{
    width: 100%;
    font-size:18px;
    color:#999;
    line-height: 40px;
    position: absolute;
    top: 60px;
  }
  .upload-item-cover i{vertical-align: middle;color:#999;}
</style>
